module.exports = __webpack_public_path__ + "img/238.375ba630.jpg";